import theme from '../../theme/theme';

const {
  colors: { black_text, list_opacity },
} = theme;

const styles = {
  scroll__wheel: {
    height: '90vh',
    overflow: 'auto',
    position: 'relative',
    paddingBottom: '2em',
  },

  menu__container: {
    height: '4.625em',
    width: '24.750em',
    padding: 0,
    margin: 0,
  },

  icons: {
    borderRadius: 0,
    paddingLeft: '1.5em',
    fontSize: '1.5em',
  },

  title: {
    color: black_text,
    fontSize: '1.250em',
    letterSpacing: '-0.031em',
    padding: 0,
    fontWeight: 'normal',
    paddingLeft: '1.5em',
  },

  overlay: {
    position: 'fixed',
    left: 0,
    bottom: 0,
    height: '2em',
    width: '100%',
    background: list_opacity,
  },
};

export default styles;
